/* Accessibility fixes */
(function () {
  'use strict';

  var ICONS = {
    prev: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path d="M15.5 4.5 8 12l7.5 7.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    next: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path d="M8.5 4.5 16 12l-7.5 7.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    pause: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>',
    play: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>',
    up: '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="18" height="18"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Carousel controls */
  function buildCarouselControls(host, label, api, hasAutoplay, itemName) {
    itemName = itemName || 'slide';
    var group = document.createElement('div');
    group.className = 'a11y-carousel-controls';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', label + ' controls');

    function makeButton(cls, text, icon) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'a11y-carousel-controls__btn ' + cls;
      btn.setAttribute('aria-label', text);
      btn.innerHTML = icon;
      return btn;
    }

    var prevBtn = makeButton('a11y-carousel-controls__prev', 'Previous ' + itemName, ICONS.prev);
    var nextBtn = makeButton('a11y-carousel-controls__next', 'Next ' + itemName, ICONS.next);
    var toggleBtn = null;
    var playing = hasAutoplay;

    function setPlaying(isPlaying) {
      playing = isPlaying;
      if (!toggleBtn) return;
      toggleBtn.setAttribute('aria-label', isPlaying ? 'Pause ' + label.toLowerCase() : 'Play ' + label.toLowerCase());
      toggleBtn.innerHTML = isPlaying ? ICONS.pause : ICONS.play;
    }

    prevBtn.addEventListener('click', function () { api.prev(); });
    nextBtn.addEventListener('click', function () { api.next(); });

    group.appendChild(prevBtn);

    if (hasAutoplay) {
      toggleBtn = makeButton('a11y-carousel-controls__toggle', '', ICONS.pause);
      toggleBtn.addEventListener('click', function () {
        if (playing) {
          api.pause();
          setPlaying(false);
        } else {
          api.play();
          setPlaying(true);
        }
      });
      group.appendChild(toggleBtn);
      setPlaying(true);
    }

    group.appendChild(nextBtn);
    host.appendChild(group);

    return { setPlaying: setPlaying };
  }

  /* Home slideshow */
  function whenFlickityReady(el, callback) {
    function check() {
      var flkty = window.Flickity && window.Flickity.data(el);
      if (flkty) {
        callback(flkty);
        return true;
      }
      return false;
    }
    if (check()) return;
    var observer = new MutationObserver(function () {
      if (check()) observer.disconnect();
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function initSlideshows() {
    var sections = document.querySelectorAll('[data-section-type="slideshow-section"]');

    Array.prototype.forEach.call(sections, function (section) {
      var slider = section.querySelector('[id^="Slideshow-"]');
      var wrapper = section.querySelector('.slideshow-wrapper');
      if (!slider || !wrapper) return;
      if (parseInt(slider.dataset.slideCount, 10) < 2) return;
      if (wrapper.querySelector('.a11y-carousel-controls')) return;

      var hasAutoplay = slider.dataset.autoplay === 'true';

      // Hide theme's duplicate pause button
      var themePause = wrapper.querySelector('.slideshow__pause');
      if (themePause) themePause.hidden = true;

      whenFlickityReady(slider, function (flkty) {
        var controls;

        function restartTimer() {
          if (flkty.player && flkty.player.state === 'playing') {
            flkty.stopPlayer();
            flkty.playPlayer();
          }
        }

        controls = buildCarouselControls(wrapper, 'Slideshow', {
          prev: function () { flkty.previous(); restartTimer(); },
          next: function () { flkty.next(); restartTimer(); },
          play: function () { flkty.playPlayer(); },
          pause: function () { flkty.stopPlayer(); }
        }, hasAutoplay);

        // Sync state when Flickity stops autoplay
        if (hasAutoplay) {
          flkty.on('pointerDown', function () { controls.setPlaying(false); });
          flkty.on('uiChange', function () { controls.setPlaying(false); });

          // Stop autoplay when focus enters from outside (keyboard / screen reader)
          wrapper.addEventListener('focusin', function (evt) {
            if (evt.relatedTarget && wrapper.contains(evt.relatedTarget)) return;
            if (evt.target.closest('.a11y-carousel-controls__toggle')) return;
            if (flkty.player && flkty.player.state !== 'stopped') {
              flkty.stopPlayer();
              controls.setPlaying(false);
            }
          });

          // Let the VoiceOver cursor move focus onto slide text
          Array.prototype.forEach.call(wrapper.querySelectorAll('.hero__text-content'), function (el) {
            if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
          });
        }
      });
    });
  }

  /* Product recipe slider */
  function initProductSlider() {
    var slider = document.getElementById('slick_product_slider');
    if (!slider || !window.jQuery || !window.jQuery.fn.slick) return;

    var $slider = window.jQuery(slider);
    if (!$slider.hasClass('slick-initialized')) return;
    if (slider.querySelectorAll('.slidess').length < 2) return;
    if (slider.querySelector('.a11y-carousel-controls')) return;

    var hasAutoplay = !!$slider.slick('slickGetOption', 'autoplay');

    buildCarouselControls(slider, 'Recipe slideshow', {
      prev: function () { $slider.slick('slickPrev'); },
      next: function () { $slider.slick('slickNext'); },
      play: function () { $slider.slick('slickPlay'); },
      pause: function () { $slider.slick('slickPause'); }
    }, hasAutoplay);
  }

  /* Testimonials slider */
  function initTestimonialSliders() {
    if (!window.jQuery || !window.jQuery.fn.slick) return;

    Array.prototype.forEach.call(document.querySelectorAll('.slick-test.slick-initialized'), function (slider) {
      var $slider = window.jQuery(slider);
      var slick = $slider.slick('getSlick');
      if (!slick || slick.slideCount < 2) return;
      if (slider.nextElementSibling && slider.nextElementSibling.classList.contains('a11y-carousel-controls-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'a11y-carousel-controls-wrap';
      slider.parentNode.insertBefore(wrap, slider.nextSibling);

      var fromControls = false;

      buildCarouselControls(wrap, 'Testimonials', {
        prev: function () { fromControls = true; $slider.slick('slickPrev'); },
        next: function () { fromControls = true; $slider.slick('slickNext'); }
      }, false, 'testimonial');

      // Announce visible testimonials
      $slider.on('afterChange', function (evt, s, current) {
        if (!fromControls) return;
        fromControls = false;
        var total = s.slideCount;
        var shown = Math.min(s.options.slidesToShow, total);
        var first = current + 1;
        var last = Math.min(current + shown, total);
        announce('Showing testimonial ' + (shown > 1 && last > first ? first + ' to ' + last : first) + ' of ' + total + '.');
      });
    });
  }

  /* Desktop nav dropdowns */
  function initDesktopNav() {
    var disclosures = document.querySelectorAll('.site-nav__disclosure');
    if (!disclosures.length) return;

    function setOpen(toggle, panel, isOpen) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.classList.toggle('is-open', isOpen);
    }

    function getPanel(toggle) {
      return document.getElementById(toggle.getAttribute('aria-controls'));
    }

    function closeDeep(scope) {
      Array.prototype.forEach.call(scope.querySelectorAll('.site-nav__toggle--deep[aria-expanded="true"]'), function (t) {
        setOpen(t, getPanel(t), false);
      });
    }

    function closeDisclosure(disclosure) {
      var toggle = disclosure.querySelector(':scope > .site-nav__toggle');
      setOpen(toggle, getPanel(toggle), false);
      disclosure.classList.remove('is-open');
      disclosure.removeAttribute('data-opened-by');
      closeDeep(disclosure);
    }

    function openDisclosure(disclosure, openedBy) {
      Array.prototype.forEach.call(disclosures, function (other) {
        if (other !== disclosure) closeDisclosure(other);
      });
      var toggle = disclosure.querySelector(':scope > .site-nav__toggle');
      setOpen(toggle, getPanel(toggle), true);
      disclosure.classList.add('is-open');
      disclosure.setAttribute('data-opened-by', openedBy);
    }

    Array.prototype.forEach.call(disclosures, function (disclosure) {
      var toggle = disclosure.querySelector(':scope > .site-nav__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function (evt) {
        evt.preventDefault();
        if (disclosure.getAttribute('data-opened-by') === 'hover') {
          // Click pins a hover-opened menu
          disclosure.setAttribute('data-opened-by', 'click');
        } else if (toggle.getAttribute('aria-expanded') === 'true') {
          closeDisclosure(disclosure);
        } else {
          openDisclosure(disclosure, 'click');
        }
      });

      // Mouse hover (theme setting "hover_menu")
      if (disclosure.dataset.hover === 'true') {
        disclosure.addEventListener('mouseenter', function () {
          if (toggle.getAttribute('aria-expanded') !== 'true') openDisclosure(disclosure, 'hover');
        });
        disclosure.addEventListener('mouseleave', function () {
          if (disclosure.getAttribute('data-opened-by') === 'hover') closeDisclosure(disclosure);
        });
      }

      // Close when keyboard focus leaves the menu item
      disclosure.addEventListener('focusout', function (evt) {
        if (evt.relatedTarget && !disclosure.contains(evt.relatedTarget)) {
          closeDisclosure(disclosure);
        }
      });

      // Escape closes innermost level
      disclosure.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Escape' && evt.key !== 'Esc') return;

        var openDeep = disclosure.querySelector('.site-nav__toggle--deep[aria-expanded="true"]');
        if (openDeep) {
          setOpen(openDeep, getPanel(openDeep), false);
          openDeep.focus();
        } else if (toggle.getAttribute('aria-expanded') === 'true') {
          closeDisclosure(disclosure);
          toggle.focus();
        } else {
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
      });

      // Third-level dropdowns
      Array.prototype.forEach.call(disclosure.querySelectorAll('.site-nav__toggle--deep'), function (deepToggle) {
        var trigger = deepToggle.closest('.site-nav__deep-dropdown-trigger');

        deepToggle.addEventListener('click', function (evt) {
          evt.preventDefault();
          var isOpen = deepToggle.getAttribute('aria-expanded') === 'true';
          closeDeep(disclosure);
          setOpen(deepToggle, getPanel(deepToggle), !isOpen);
        });

        trigger.addEventListener('focusout', function (evt) {
          if (evt.relatedTarget && !trigger.contains(evt.relatedTarget)) {
            setOpen(deepToggle, getPanel(deepToggle), false);
          }
        });
      });
    });

    // Click outside closes any open dropdown
    document.addEventListener('click', function (evt) {
      Array.prototype.forEach.call(disclosures, function (disclosure) {
        if (!disclosure.contains(evt.target)) closeDisclosure(disclosure);
      });
    });
  }

  /* Live region */
  var liveRegions = {};

  function announce(message, assertive) {
    if (!message) return;
    var type = assertive ? 'assertive' : 'polite';
    var region = liveRegions[type];

    if (!region) {
      region = document.createElement('div');
      region.className = 'visually-hidden';
      region.setAttribute('aria-live', type);
      region.setAttribute('aria-atomic', 'true');
      if (assertive) region.setAttribute('role', 'alert');
      document.body.appendChild(region);
      liveRegions[type] = region;
    }

    // Clear so repeats are announced
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 100);
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) &&
      window.getComputedStyle(el).visibility !== 'hidden';
  }

  function getFocusable(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return isVisible(el) && !el.closest('[inert], [aria-hidden="true"]');
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat).replace(/<[^>]*>/g, '');
    }
    return '';
  }

  function itemsText(count) {
    return count + ' ' + (count === 1 ? 'item' : 'items');
  }

  /* Drawer dialog focus handling */
  function initModalDrawer(drawer) {
    if (!drawer) return;

    var inertEls = [];
    var lastOutsideFocus = null;
    var isOpen = false;

    document.addEventListener('focusin', function (evt) {
      if (!drawer.contains(evt.target)) lastOutsideFocus = evt.target;
    }, true);

    function setBackgroundInert(on) {
      if (on) {
        var el = drawer;
        while (el && el.parentElement && el !== document.body) {
          Array.prototype.forEach.call(el.parentElement.children, function (sibling) {
            if (sibling === el || sibling.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName)) return;
            // Keep our own live regions reachable
            if (sibling.hasAttribute('aria-live')) return;
            sibling.inert = true;
            inertEls.push(sibling);
          });
          el = el.parentElement;
        }
      } else {
        inertEls.forEach(function (sibling) { sibling.inert = false; });
        inertEls = [];
      }
    }

    function onOpen() {
      isOpen = true;
      setBackgroundInert(true);
    }

    function onClose() {
      isOpen = false;
      setBackgroundInert(false);

      // Return focus for non-click opens too
      setTimeout(function () {
        var active = document.activeElement;
        if (active && active !== document.body && !drawer.contains(active)) return;
        if (lastOutsideFocus && document.contains(lastOutsideFocus) && isVisible(lastOutsideFocus)) {
          lastOutsideFocus.focus();
        }
      }, 600);
    }

    new MutationObserver(function () {
      var open = drawer.classList.contains('drawer--is-open');
      if (open && !isOpen) onOpen();
      if (!open && isOpen) onClose();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Tab' || !isOpen) return;

      var focusable = getFocusable(drawer);
      if (!focusable.length) {
        evt.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (evt.shiftKey && (active === first || active === drawer || !drawer.contains(active))) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && (active === last || !drawer.contains(active))) {
        evt.preventDefault();
        first.focus();
      }
    });
  }

  /* Cart announcements and focus */
  function initCart() {
    initModalDrawer(document.getElementById('CartDrawer'));

    // Cart link label with item count
    function updateCountLabel(count) {
      Array.prototype.forEach.call(document.querySelectorAll('.js-drawer-open-cart[aria-label]'), function (el) {
        var label = el.getAttribute('aria-label').split(',')[0];
        el.setAttribute('aria-label', label + ', ' + itemsText(count));
      });
    }

    function refreshCount() {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateCountLabel(cart.item_count); })
        .catch(function () {});
    }

    // Add to Cart
    document.addEventListener('ajaxProduct:added', function (evt) {
      var item = evt.detail && evt.detail.product;
      if (item && item.product_title) {
        var name = item.product_title;
        if (item.variant_title) name += ', ' + item.variant_title;
        announce('Added to cart: ' + name + '.');
      } else {
        announce('Item added to cart.');
      }
      refreshCount();
    });

    document.addEventListener('ajaxProduct:error', function (evt) {
      var msg = evt.detail && evt.detail.errorMessage;
      if (msg && typeof msg === 'object') msg = Object.values(msg).join(' ');
      announce(msg || 'Sorry, this item could not be added to your cart.', true);
    });

    // Quantity changes in the drawer / cart page
    document.addEventListener('cart:updated', function (evt) {
      var cart = evt.detail && evt.detail.cart;
      if (!cart) return;
      updateCountLabel(cart.item_count);

      if (cart.item_count === 0) {
        announce('Your cart is empty.');
      } else {
        var subtotal = formatMoney(cart.total_price);
        announce('Cart updated. ' + itemsText(cart.item_count) + (subtotal ? ', subtotal ' + subtotal : '') + '.');
      }
    });

    // Restore focus after cart re-render
    var pendingFocus = null;

    function rememberFocus(evt) {
      var control = evt.target.closest('.js-qty__adjust--minus, .js-qty__adjust--plus, .js-qty__num');
      var item = control && control.closest('.cart__item[data-key]');
      if (!item || !item.closest('[data-products]')) return;

      var type = control.classList.contains('js-qty__num') ? '.js-qty__num'
        : control.classList.contains('js-qty__adjust--minus') ? '.js-qty__adjust--minus'
        : '.js-qty__adjust--plus';

      pendingFocus = { key: item.dataset.key, selector: type, container: item.closest('[data-products]'), time: Date.now() };
    }

    document.addEventListener('click', rememberFocus, true);
    document.addEventListener('change', rememberFocus, true);

    Array.prototype.forEach.call(document.querySelectorAll('[data-products]'), function (container) {
      new MutationObserver(function () {
        if (!pendingFocus || pendingFocus.container !== container) return;
        if (Date.now() - pendingFocus.time > 10000) {
          pendingFocus = null;
          return;
        }

        var target = null;
        var item = container.querySelector('.cart__item[data-key="' + pendingFocus.key.replace(/"/g, '\\"') + '"]');
        if (item) {
          target = item.querySelector(pendingFocus.selector);
        } else {
          // Item removed: focus next item or drawer
          var drawer = container.closest('.drawer');
          var remaining = getFocusable(container);
          target = remaining[0] || (drawer && drawer.querySelector('.js-drawer-close'));
        }

        pendingFocus = null;
        if (target) target.focus();
      }).observe(container, { childList: true });
    });

    // Add to Cart button: expose the loading state
    Array.prototype.forEach.call(document.querySelectorAll('[data-add-to-cart]'), function (btn) {
      new MutationObserver(function () {
        var loading = btn.classList.contains('btn--loading');
        if (loading && btn.getAttribute('aria-busy') !== 'true') {
          btn.setAttribute('aria-busy', 'true');
          announce('Adding to cart.');
        } else if (!loading && btn.hasAttribute('aria-busy')) {
          btn.removeAttribute('aria-busy');
        }
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* Search */
  function initSearch() {
    var toggles = document.querySelectorAll('.js-search-header');
    var opener = null;
    var headerSearchOpen = false;

    function setExpanded(value) {
      Array.prototype.forEach.call(toggles, function (t) {
        t.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(toggles, function (t) {
      t.addEventListener('click', function () { opener = t; }, true);
    });

    document.addEventListener('predictive-search:open', function (evt) {
      if (!evt.detail || evt.detail.context !== 'header') return;
      headerSearchOpen = true;
      setExpanded(true);
    });

    document.addEventListener('predictive-search:close-all', function () {
      if (!headerSearchOpen) return;
      headerSearchOpen = false;
      setExpanded(false);
      closeCloudSearch();

      // Return focus to search button
      setTimeout(function () {
        if (opener && isVisible(opener)) opener.focus();
      }, 50);
    });

    // Closed search panel: hide from AT and keyboard, clear stuck is-transitioning
    var panel = document.getElementById('HeaderSearch');
    if (panel) {
      var clearTimer;
      var syncPanel = function () {
        var open = panel.classList.contains('is-active');
        panel.inert = !open;
        if (open) {
          panel.removeAttribute('aria-hidden');
          clearTimeout(clearTimer);
        } else {
          panel.setAttribute('aria-hidden', 'true');
          clearTimeout(clearTimer);
          clearTimer = setTimeout(function () {
            if (!panel.classList.contains('is-active')) panel.classList.remove('is-transitioning');
          }, 600);
        }
      };
      new MutationObserver(syncPanel).observe(panel, { attributes: true, attributeFilter: ['class'] });
      syncPanel();
    }

    // Close the Cloud Search app dropdown with the header search
    function closeCloudSearch() {
      var input = document.getElementById('Search-header');
      if (!input || !document.getElementById('cloud-search-results')) return;
      ['keydown', 'keyup'].forEach(function (type) {
        input.dispatchEvent(new KeyboardEvent(type, { key: 'Escape', code: 'Escape', keyCode: 27, which: 27, bubbles: true }));
      });
      setTimeout(function () {
        if (!document.getElementById('cloud-search-results')) return;
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new KeyboardEvent('keyup', { key: 'Backspace', bubbles: true }));
      }, 100);
    }

    // Announce how many results the live search found
    Array.prototype.forEach.call(document.querySelectorAll('predictive-search'), function (component) {
      var results = component.querySelector('#predictive-search');
      var input = component.querySelector('input[type="search"]');
      if (!results || !input || component.dataset.enabled === 'false') return;

      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var term = input.value.trim();
          if (!term || !component.classList.contains('is-active')) return;

          var count = results.querySelectorAll('.grid-product').length +
            results.querySelectorAll('[data-type-collections] li, [data-type-pages] li').length;

          if (count) {
            announce(count + (count === 1 ? ' result' : ' results') + ' for ' + term + '. Press Tab to browse them.');
          } else {
            announce('No results for ' + term + '.');
          }
        }, 200);
      }).observe(results, { childList: true });
    });
  }

  /* Shipping popup dialog */
  function initShippingModal() {
    var modal = document.getElementById('myModal2');
    var opener = document.getElementById('shipping');
    if (!modal) return;
    var closeBtn = modal.querySelector('.close');
    var dialog = modal.querySelector('[role="dialog"]') || modal;
    var wasOpen = false;
    var returnTo = null;

    function isOpen() { return getComputedStyle(modal).display !== 'none'; }

    function close() { modal.style.display = 'none'; }

    function sync() {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        returnTo = document.activeElement && document.activeElement !== document.body ? document.activeElement : opener;
        setTimeout(function () { (closeBtn || dialog).focus(); }, 0);
      } else {
        // After the theme's own Escape handler (it blurs)
        setTimeout(function () {
          if (returnTo && isVisible(returnTo)) returnTo.focus();
        }, 50);
      }
    }

    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });

    if (closeBtn) closeBtn.addEventListener('click', close);

    // Click on the backdrop closes
    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) close();
    });

    modal.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') {
        evt.preventDefault();
        close();
        return;
      }
      if (evt.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        isVisible
      );
      if (!items.length) { evt.preventDefault(); return; }
      var first = items[0];
      var last = items[items.length - 1];
      if (evt.shiftKey && document.activeElement === first) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    });
  }

  /* Cloud Search filter headers: keyboard + expanded state */
  function initCollectionFilters() {
    function enhance() {
      Array.prototype.forEach.call(document.querySelectorAll('.cloud-search-filter__name'), function (head) {
        if (!head.hasAttribute('role')) {
          head.setAttribute('role', 'button');
          head.setAttribute('tabindex', '0');
          head.addEventListener('keydown', function (evt) {
            if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
              evt.preventDefault();
              head.click();
            }
          });
        }
        var expanded = head.querySelector('.cloud-search-filter__collapse') ? 'true' : 'false';
        if (head.getAttribute('aria-expanded') !== expanded) head.setAttribute('aria-expanded', expanded);
        Array.prototype.forEach.call(head.querySelectorAll('.cloud-search-filter__expand, .cloud-search-filter__collapse'), function (icon) {
          if (!icon.hasAttribute('aria-hidden')) icon.setAttribute('aria-hidden', 'true');
        });
      });
    }

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enhance();
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    enhance();
  }

  /* Back to top */
  function initBackToTop() {
    if (document.querySelector('.a11y-back-to-top')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a11y-back-to-top';
    btn.innerHTML = ICONS.up + '<span class="a11y-back-to-top__text">Top</span>';
    btn.setAttribute('aria-label', 'Back to top');
    btn.hidden = true;
    document.body.appendChild(btn);

    var threshold = 400;
    var ticking = false;

    function update() {
      btn.hidden = window.pageYOffset < threshold;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

      // Move focus to the top links region
      var target = document.getElementById('top-back') || document.body;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });

    update();
  }

  /* role="button" links: Space activates */
  function initLinkButtons() {
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== ' ' && evt.key !== 'Spacebar') return;
      var el = evt.target;
      if (el && el.tagName === 'A' && el.getAttribute('role') === 'button') {
        evt.preventDefault(); // stop the page from scrolling
        el.click();
      }
    });
  }

  function init() {
    initLinkButtons();
    initDesktopNav();
    initModalDrawer(document.getElementById('NavDrawer')); // mobile menu, snippets/drawer-menu.liquid
    initCart();
    initSearch();
    initSlideshows();
    initProductSlider();
    initTestimonialSliders();
    initShippingModal();
    initCollectionFilters();
    initBackToTop();
    initSoldOutVariants();
    initFilterDrawer();
    initProductPopup();
  }

  /* Product page popup (sections/main-product.liquid #openPop / #myModal) */
  function initProductPopup() {
    var trigger = document.getElementById('openPop');
    var modal = document.getElementById('myModal');
    if (!trigger || !modal) return;
    var close = modal.querySelector('.closes');
    var content = modal.querySelector('.modal-content');

    function activateOnKey(el) {
      el.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
          evt.preventDefault();
          el.click();
        }
      });
    }

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', 'myModal');
    trigger.setAttribute('aria-expanded', 'false');
    activateOnKey(trigger);

    (content || modal).setAttribute('role', 'dialog');
    (content || modal).setAttribute('aria-modal', 'true');
    (content || modal).setAttribute('aria-label', trigger.getAttribute('alt') || 'More information');
    (content || modal).setAttribute('tabindex', '-1');

    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close');
      activateOnKey(close);
    }

    function isOpen() {
      return modal.style.display === 'block';
    }

    var wasOpen = false;
    new MutationObserver(function () {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) (close || content || modal).focus();
      else trigger.focus();
    }).observe(modal, { attributes: true, attributeFilter: ['style'] });

    // Escape closes, Tab stays inside the popup
    document.addEventListener('keydown', function (evt) {
      if (!isOpen()) return;
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        modal.style.display = 'none';
        return;
      }
      if (evt.key !== 'Tab') return;
      var items = Array.prototype.slice.call(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'));
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (!modal.contains(document.activeElement) || (evt.shiftKey && document.activeElement === first)) {
        evt.preventDefault();
        (evt.shiftKey ? last : first).focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    });
  }

  /* Cloud Search mobile filter: trigger as button, drawer as modal dialog */
  function initFilterDrawer() {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])';
    var openDrawer = null;
    var inerted = [];

    function isShown(el) {
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.right > 0 && r.left < window.innerWidth;
    }

    // Drawer = fixed-position ancestor of the filter headers
    function findDrawer() {
      var heads = document.querySelectorAll('.cloud-search-filter__name');
      for (var i = 0; i < heads.length; i++) {
        var el = heads[i].parentElement;
        while (el && el !== document.body) {
          if (window.getComputedStyle(el).position === 'fixed') return isShown(el) ? el : null;
          el = el.parentElement;
        }
      }
      return null;
    }

    function triggers() {
      return document.querySelectorAll('.cloud-search-page-controls__filters-link');
    }

    function enhanceTriggers() {
      Array.prototype.forEach.call(triggers(), function (link) {
        if (link.hasAttribute('data-a11y-filter')) return;
        link.setAttribute('data-a11y-filter', '');
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-expanded', 'false');
        if (!link.hasAttribute('href')) link.setAttribute('tabindex', '0');
        Array.prototype.forEach.call(link.querySelectorAll('svg, img'), function (icon) {
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('focusable', 'false');
        });
        link.addEventListener('keydown', function (evt) {
          if (evt.key === ' ' || evt.key === 'Spacebar' || (evt.key === 'Enter' && !link.hasAttribute('href'))) {
            evt.preventDefault();
            link.click();
          }
        });
      });
    }

    function closeControl(drawer) {
      return drawer.querySelector('[class*="close"]:not(svg):not(path), [aria-label*="lose"]');
    }

    function enhanceDrawer(drawer) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', 'Filters');
      drawer.setAttribute('tabindex', '-1');
      var close = closeControl(drawer);
      if (close) {
        if (close.tagName !== 'BUTTON' && close.tagName !== 'A') {
          close.setAttribute('role', 'button');
          close.setAttribute('tabindex', '0');
          close.addEventListener('keydown', function (evt) {
            if (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'Spacebar') {
              evt.preventDefault();
              close.click();
            }
          });
        }
        close.setAttribute('aria-label', 'Close filters');
        Array.prototype.forEach.call(close.querySelectorAll('svg'), function (icon) {
          icon.setAttribute('aria-hidden', 'true');
        });
      }
    }

    // Hide page content outside the drawer from screen readers
    function setInert(drawer, on) {
      if (!on) {
        inerted.forEach(function (el) {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        });
        inerted = [];
        return;
      }
      var node = drawer;
      while (node && node !== document.body) {
        Array.prototype.forEach.call(node.parentElement.children, function (sib) {
          if (sib === node || sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE' || sib.hasAttribute('inert')) return;
          sib.setAttribute('inert', '');
          sib.setAttribute('aria-hidden', 'true');
          inerted.push(sib);
        });
        node = node.parentElement;
      }
    }

    function onKeydown(evt) {
      if (!openDrawer) return;
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        var close = closeControl(openDrawer);
        if (close) close.click();
        return;
      }
      if (evt.key !== 'Tab') return;
      var items = Array.prototype.filter.call(openDrawer.querySelectorAll(FOCUSABLE), isShown);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (evt.shiftKey && (document.activeElement === first || document.activeElement === openDrawer)) {
        evt.preventDefault();
        last.focus();
      } else if (!evt.shiftKey && document.activeElement === last) {
        evt.preventDefault();
        first.focus();
      }
    }

    function sync() {
      enhanceTriggers();
      var drawer = findDrawer();
      if (drawer && !openDrawer) {
        openDrawer = drawer;
        enhanceDrawer(drawer);
        setInert(drawer, true);
        Array.prototype.forEach.call(triggers(), function (t) { t.setAttribute('aria-expanded', 'true'); });
        drawer.focus();
      } else if (!drawer && openDrawer) {
        openDrawer = null;
        setInert(null, false);
        var back = null;
        Array.prototype.forEach.call(triggers(), function (t) {
          t.setAttribute('aria-expanded', 'false');
          if (!back && isShown(t)) back = t;
        });
        if (back) back.focus();
      }
    }

    document.addEventListener('keydown', onKeydown);

    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        sync();
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync();
  }

  /* Announce sold-out variant buttons (theme toggles .disabled on the label) */
  function initSoldOutVariants() {
    function sync(label) {
      var tag = label.querySelector('.a11y-sold-out');
      var soldOut = label.classList.contains('disabled');
      if (soldOut && !tag) {
        tag = document.createElement('span');
        tag.className = 'a11y-sold-out visually-hidden';
        tag.textContent = ', Sold out';
        label.appendChild(tag);
      } else if (!soldOut && tag) {
        tag.remove();
      }
    }

    document.querySelectorAll('.variant-input .variant__button-label').forEach(function (label) {
      sync(label);
      new MutationObserver(function () { sync(label); })
        .observe(label, { attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// External link warning
document.addEventListener("DOMContentLoaded", function () {
  const EXTERNAL_SUFFIX = "Redirecting to a third-party website (opens in a new tab).";

  const excludedLinks = [
    

  ];

  const normalizeHost = (host) => host.replace(/^www\./, "");
  const currentHost = normalizeHost(window.location.hostname);

  const isExcluded = (href) =>
    excludedLinks.some((excluded) => href.startsWith(excluded));

  const isExternalLink = (href) => {
    try {
      const url = new URL(href, window.location.origin); // handles relative URLs
      if (url.protocol !== "http:" && url.protocol !== "https:") return false;
      return normalizeHost(url.hostname) !== currentHost;
    } catch {
      return false;
    }
  };

  // Link name from text, alt or aria-label
  const getLinkName = (link) => {
    const clone = link.cloneNode(true);
    clone.querySelectorAll('[aria-hidden="true"], title').forEach((el) => el.remove());
    const text = clone.textContent.replace(/\s+/g, " ").trim();
    if (text) return text;

    const graphic = link.querySelector("img[alt], svg[aria-label]");
    if (!graphic) return "";
    return (graphic.getAttribute("alt") || graphic.getAttribute("aria-label") || "").trim();
  };

  const enhanceExternalLinks = () => {
    document.querySelectorAll("a[href]").forEach((link) => {
      const href = link.getAttribute("href");

      if (
        isExcluded(href) ||
        link.matches("li[data-submenu-parent] > a") ||
        !isExternalLink(href)
      ) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      if (!link.hasAttribute("aria-label")) {
        const name = getLinkName(link);
        link.setAttribute("aria-label", name ? `${name}, ${EXTERNAL_SUFFIX}` : EXTERNAL_SUFFIX);
      }
    });
  };

  const enhanceEmailLinks = () => {
    document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
      if (link.hasAttribute("aria-label")) return;

      const name = getLinkName(link);
      if (name) link.setAttribute("aria-label", `Email address: ${name}`);
    });
  };

  enhanceExternalLinks();
  enhanceEmailLinks();
});
